<template>
  <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
    <template #default>
      <div class="d-flex justify-center mt-6">
        <v-card
          :width="mobile ? '90%' : '65%'"
          max-height="78vh"
          color="white"
          elevation="3"
          class="d-flex flex-column"
        >
          <v-toolbar flat density="compact" color="white">
            <div class="d-flex align-center">
              <v-btn icon color="primary" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
            <v-chip variant="tonal" color="primary" v-if="transferModel.transferId">
              ID: {{ transferModel.transferId }}
            </v-chip>
    
            <v-spacer />
          </v-toolbar>

          <v-form ref="form" class="card-scroll">
            <v-row dense class="pa-8 flex-grow-1">
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-2">
                    <v-icon color="primary" class="mr-2" size="small">mdi-package-variant</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Estoques</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-2"></v-divider>
              </v-col>
  
              <v-row dense justify="center" class="mt-2">
                <v-col cols="12" md="5" sm="6">
                  <BaseAutoComplete
                    v-model="transferModel.originStockId"
                    store-module="stock"
                    items-state="lstStock"
                    :item-title="item => `${item.stockId} - ${item.stockName}`"
                    item-value="stockId"
                    action="search"
                    label="Estoque origem"
                    :rules="[v => !!v || 'Campo obrigatório']"
                    :disabled="transfer.isUpdate"
                  />
                </v-col>
                <v-col cols="12" md="5" sm="6">
                  <BaseAutoComplete
                    v-model="transferModel.destinationStockId"
                    store-module="stock"
                    items-state="lstStock"
                    :item-title="item => `${item.stockId} - ${item.stockName}`"
                    item-value="stockId"
                    action="search"
                    label="Estoque destino"
                    :rules="[v => !!v || 'Campo obrigatório']"
                    :disabled="transfer.isUpdate"
                  />
                </v-col>
              </v-row>
              
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-2">
                    <v-icon color="primary" class="mr-2" size="small">mdi-sprout</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Produtos</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-2"></v-divider>
              </v-col>
              
              <v-row dense justify="center" class="mt-2">
                <v-col cols="10" md="5">
                    <div class="d-flex justify-center">
                        <BaseAutoComplete
                          v-model="product.productId"
                          store-module="product"
                          items-state="lstProduct"
                          :item-title="item => `${item.productId} - ${item.productName}`"
                          item-value="productId"
                          action="search"
                          label="Produto"
                          :disabled="transfer.isUpdate"
                        />
                    </div>
                </v-col>
                <v-col cols="6" md="2" sm="3">
                    <div>
                        <v-text-field
                            v-model="quantity"
                            label="Quantidade"
                            variant="outlined"
                            rounded
                            color="primary"
                            density="compact"
                            @keyup.enter="addItems()"
                            :disabled="transfer.isUpdate"
                        />
                    </div>
                </v-col>
                <v-col cols="4" md="1" sm="1">
                    <v-btn
                        rounded
                        color="primary"
                        @click="addItems()"
                        :disabled="transfer.isUpdate"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
              </v-row>
              <v-col cols="12">
                  <v-data-table
                      :headers="transfer.headersItems"
                      :items="transfer.lstTransferItems"
                      no-data-text="Nenhum produto adicionado"
                      class="card-scroll"
                      :items-per-page="-1"
                      hide-default-footer
                      :disabled="transfer.isUpdate"
                  >
                      <template #headers="{ columns }">
                          <tr>
                              <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                                  {{ column.title }}
                              </th>
                          </tr>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                          <v-icon color="red" icon="mdi-delete"  @click="removeItem(item.productId)" :disabled="transfer.isUpdate"></v-icon>
                      </template>
                  </v-data-table>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="mt-n6 pb-6 pr-6">
            <div class="d-flex flex-column flex-md-row w-100 justify-end">
              <v-btn
                rounded
                variant="flat"
                @click="close()"
              >
                Cancelar
              </v-btn>
              <v-btn
                rounded
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="save()"
                :disabled="transfer.isUpdate"
              >
                Salvar
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'
import BaseAutoComplete from '@/components/BaseAutoComplete.vue';

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    transferId: '',
    quantity: ''
  }),
  components: {
    BaseAutoComplete
  },
  computed: {
    transfer: {
      get() {
        return this.$store.state.transfer
      }
    },
    transferModel: {
      get() {
          return this.$store.state.transfer.transfer
      },
    },
    stock: {
        get() {
            return this.$store.state.stock
        }
    },
    product: {
        get() {
            return this.$store.state.product
        }
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.transferId || this.$route.name == 'NewTransfer')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'TransferGrid' })
        }
      }
    },
    category: {
        get() {
            return this.$store.state.category
        }
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      const success = await this.$store.dispatch("transfer/save")
      if (success) {
        this.$store.commit('transfer/setShouldReload', true)
        this.close()
      }
    },
    cleanFields() {
        this.product.productId = null
        this.quantity = ''
    },
    close() {
        this.$router.push({ name: 'TransferGrid' })
        this.cleanFields()
        this.$store.commit('transfer/setTransfer', {})
        this.$store.commit('transfer/setLstTransferItems', [])
    },
    async deleteTransfer() {
      const success = await this.$store.dispatch("transfer/delete")
      if (success) {
        this.$store.commit('transfer/setShouldReload', true)
        this.close()
      }
    },
    addItems() {
        const product = this.product.lstProduct.find(
            p => p.productId === this.product.productId
        )

        if (!product) return

        this.transfer.lstTransferItems.push({
            productId: product.productId,
            productName: product.productName,
            quantity: this.quantity
        })
        this.cleanFields()
    },
    removeItem(itemId) {
        const index = this.transfer.lstTransferItems.findIndex(item => item.productId === itemId)
        this.transfer.lstTransferItems.splice(index, 1)
    },
  },
  watch: {
    '$route.params.transferId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('transfer/find', id)
          await this.$store.dispatch('transfer/findList', id)
          
          if (this.transferModel.originStockId) {
            await this.$store.dispatch('stock/find', this.transferModel.originStockId)
            if (!this.stock.lstStock.find(s => s.stockId === this.stock.stock.stockId)) {
              this.stock.lstStock.unshift(this.stock.stock)
            }
          }
          if (this.transferModel.destinationStockId) {
            await this.$store.dispatch('stock/find', this.transferModel.destinationStockId)
            if (!this.stock.lstStock.find(s => s.stockId === this.stock.stock.stockId)) {
              this.stock.lstStock.unshift(this.stock.stock)
            }
          }
        } else {
          this.$store.commit('transfer/initForm')
        }
      }
    }
  }
}
</script>


<style>

.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>